import {
  IMember,
  INewUser,
  IRedactedMember,
  IRedactedUser
} from "@wingspanhq/users/dist/lib/interfaces";
import { wsName } from "@wingspanhq/utils/dist/name/wsName";

export const ADMIN_SCOPE_GROUP_ID = "Qk5amjWDHoHeLXN1DCR0yk";
export const PAYMENTS_SCOPE_GROUP_ID = "qX_ZUDUzFkmQDyZeGmR3XF";
export const COLLABORATORS_SCOPE_GROUP_ID = "6270714525b71672ee07409d";
export const FINANCES_SCOPE_GROUP_ID = "mnTAr3m5HJLNoKdL8ntm10";
export const DOCUMENTS_SCOPE_GROUP_ID = "608219e297b39a1ddd573352";

export const scopeGroups = {
  [ADMIN_SCOPE_GROUP_ID]: {
    scopeGroupId: ADMIN_SCOPE_GROUP_ID,
    title: "Admin",
    scopes: "Full account access"
  },
  [PAYMENTS_SCOPE_GROUP_ID]: {
    scopeGroupId: PAYMENTS_SCOPE_GROUP_ID,
    title: "Payments",
    scopes: "Invoicing, payouts, contacts"
  },
  [COLLABORATORS_SCOPE_GROUP_ID]: {
    scopeGroupId: COLLABORATORS_SCOPE_GROUP_ID,
    title: "Contractors",
    scopes: "Add contractors"
  },
  [FINANCES_SCOPE_GROUP_ID]: {
    scopeGroupId: FINANCES_SCOPE_GROUP_ID,
    title: "Finances",
    scopes: "Income & expenses, taxes"
  },
  [DOCUMENTS_SCOPE_GROUP_ID]: {
    scopeGroupId: DOCUMENTS_SCOPE_GROUP_ID,
    title: "Documents",
    scopes: "Private & Public Documents"
  }
} as const;

export type ScopeGroupId = keyof typeof scopeGroups;

export const hasAdminScope = (scopeGroupIds: Array<string>) => {
  return scopeGroupIds.includes(ADMIN_SCOPE_GROUP_ID);
};

export const hasPaymentsScope = (scopeGroupIds: Array<string>) => {
  return scopeGroupIds.includes(PAYMENTS_SCOPE_GROUP_ID);
};

export const hasCollaboratorsScope = (scopeGroupIds: Array<string>) => {
  return scopeGroupIds.includes(COLLABORATORS_SCOPE_GROUP_ID);
};

export const hasFinancesScope = (scopeGroupIds: Array<string>) => {
  return scopeGroupIds.includes(FINANCES_SCOPE_GROUP_ID);
};

export const hasDocumentsScope = (scopeGroupIds: Array<string>) => {
  return scopeGroupIds.includes(DOCUMENTS_SCOPE_GROUP_ID);
};

export const getAuthorizedAccountName = (
  member: IMember | IRedactedMember | undefined,
  user: INewUser | IRedactedUser
): string => {
  const accountsNames = wsName({
    member,
    user
  } as Parameters<typeof wsName>[0]);

  const accountName = accountsNames.getResolvedName();

  if (accountName) {
    return accountName;
  }

  if (member?.profile?.company?.name) {
    return member.profile.company.name as string;
  } else if (user.profile?.firstName && user.profile.lastName) {
    return `${user.profile.firstName} ${user.profile.lastName}`;
  } else if (user.email) {
    return user.email;
  } else if (member?.user?.email) {
    return member.user.email;
  }

  return "";
};

export const getMemberName = (
  member: IMember | IRedactedMember | undefined
) => {
  if (member) {
    if (member.profile?.company?.name) {
      return member.profile?.company?.name;
    }
  }
  return "";
};
